import React, { useState } from 'react';
import { FlagIcon, PencilLineIcon } from 'lucide-react';
import { budgetRows } from '../../data/ledger';
import { useAssessment } from '../../contexts/AssessmentContext';
import { formatEur, formatSigned } from '../../utils/scoring';
import { FlagDrawer } from './FlagDrawer';
export function BudgetTable() {
  const {
    flags,
    saveFlag,
    removeFlag,
    locked,
    timeUp
  } = useAssessment();
  const [drawer, setDrawer] = useState<{
    rowId: string;
    label: string;
    kind: 'flag' | 'correction';
  } | null>(null);
  const readOnly = locked || timeUp;
  return <div className="flex h-full flex-col" data-id="element-154" data-mp="82gf5oxbph0x">
      <div className="border-b border-slate-200 bg-white px-5 py-3" data-id="element-155" data-mp="cyoq0q4hmo2a">
        <h2 className="text-sm font-semibold text-slate-900" data-id="element-156" data-mp="hyjhaus6dfnv">
          Q2 2026 profit &amp; loss — actual against budget, EUR
        </h2>
        <p className="mt-0.5 text-xs text-slate-500" data-id="element-157" data-mp="1oe3l1od4z5ur">
          

        </p>
      </div>

      <div className="flex-1 overflow-auto" data-id="element-158" data-mp="1tcx19ojt5aym">
        <table className="w-full border-collapse text-sm" data-id="element-159" data-mp="1tfsz7cvnnzn2">
          <thead className="sticky top-0 z-10 bg-slate-100 text-left" data-id="element-160" data-mp="3atkivfar7qjv">
            <tr className="text-[11px] uppercase tracking-wider text-slate-600" data-id="element-161" data-mp="36sqw4p91shsk">
              <th className="border-b border-slate-200 px-4 py-2.5 font-semibold" data-id="element-162" data-mp="31u75wcnf8jue">Line</th>
              <th className="border-b border-slate-200 px-4 py-2.5 text-right font-semibold" data-id="element-163" data-mp="31w0cxt1y562x">Prior period (Q1)</th>
              <th className="border-b border-slate-200 px-4 py-2.5 text-right font-semibold" data-id="element-164" data-mp="2rvrgqf7yfknj">Actual (Q2)</th>
              <th className="border-b border-slate-200 px-4 py-2.5 text-right font-semibold" data-id="element-165" data-mp="2n4rhh3bd4qhv">Budget (Q2)</th>
              <th className="border-b border-slate-200 px-4 py-2.5 text-right font-semibold" data-id="element-166" data-mp="2j2wkuc4dn1af">Variance</th>
              <th className="border-b border-slate-200 px-4 py-2.5 text-right font-semibold" data-id="element-167" data-mp="2e5nzk2nxmh4y">Var %</th>
              <th className="border-b border-slate-200 px-4 py-2.5 font-semibold" data-id="element-168" data-mp="294gre2hvnfxr">Actions</th>
            </tr>
          </thead>
          <tbody data-id="element-169" data-mp="24773ira4zcc1">
            {budgetRows.map(row => {
            const entry = flags[row.id];
            const variance = row.actual - row.budget;
            const pct = variance / Math.abs(row.budget) * 100;
            return <React.Fragment key={row.id} data-id="element-170" data-mp="1limuwyrpphhb">
                  <tr className="border-b border-slate-100 bg-white transition-colors hover:bg-slate-50" data-id="element-171" data-mp="1ljxyaxh8wn7w">
                    <td className="px-4 py-2.5" data-id="element-172" data-mp="1pjzzl5j2jemn">
                      <p className="font-medium text-slate-900" data-id="element-173" data-mp="2d913cfgyi1ll">{row.line}</p>
                      <p className="font-mono-num text-xs text-slate-500" data-id="element-174" data-mp="2i8dxzme2kcyq">{row.id}</p>
                    </td>
                    <td className="whitespace-nowrap px-4 py-2.5 text-right font-mono-num text-slate-700" data-id="element-175" data-mp="24hioq8znrtum">
                      {formatEur(row.prior)}
                    </td>
                    <td className="whitespace-nowrap px-4 py-2.5 text-right font-mono-num text-slate-900" data-id="element-176" data-mp="28g81q0gsb9dq">
                      {formatEur(row.actual)}
                    </td>
                    <td className="whitespace-nowrap px-4 py-2.5 text-right font-mono-num text-slate-700" data-id="element-177" data-mp="3106jkvqt6vwf">
                      {formatEur(row.budget)}
                    </td>
                    <td className="whitespace-nowrap px-4 py-2.5 text-right font-mono-num text-slate-900" data-id="element-178" data-mp="kk1um0c7h9wn">
                      {formatSigned(variance)}
                    </td>
                    <td className="whitespace-nowrap px-4 py-2.5 text-right font-mono-num text-slate-900" data-id="element-179" data-mp="uacyjmvw3j3j">
                      {pct >= 0 ? '+' : '−'}
                      {Math.abs(pct).toFixed(1)}%
                    </td>
                    <td className="whitespace-nowrap px-4 py-2.5" data-id="element-180" data-mp="1nih6yudczua">
                      <div className="flex items-center gap-1.5" data-id="element-181" data-mp="gjhx2vnq049z">
                        <button type="button" disabled={readOnly} onClick={() => setDrawer({
                      rowId: row.id,
                      label: row.line,
                      kind: 'flag'
                    })} className="inline-flex items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium text-slate-600 transition-colors hover:border-slate-300 hover:text-slate-900 disabled:opacity-40" data-id="element-182" data-mp="bk4zpgz83et5">
                          <FlagIcon className="h-3 w-3" data-id="element-183" data-mp="1jdtiz84fi94" />
                          Flag
                        </button>
                        <button type="button" disabled={readOnly} onClick={() => setDrawer({
                      rowId: row.id,
                      label: row.line,
                      kind: 'correction'
                    })} className="inline-flex items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-medium text-slate-600 transition-colors hover:border-slate-300 hover:text-slate-900 disabled:opacity-40" data-id="element-184" data-mp="ahpqrk3hteaj">
                          <PencilLineIcon className="h-3 w-3" data-id="element-185" data-mp="y7k402rq54vb" />
                          Correct
                        </button>
                        {entry && <span className="rounded-full border border-teal-200 bg-teal-50 px-2 py-0.5 text-[11px] font-medium text-teal-800" data-id="element-186" data-mp="136wm6a7nhnrk">
                            {entry.kind === 'correction' ? 'corrected' : 'flagged'}
                          </span>}
                      </div>
                    </td>
                  </tr>
                  {entry && <tr className="bg-teal-50/40" data-id="element-187" data-mp="zcdfc1h6h01u">
                      <td colSpan={7} className="border-b border-slate-100 px-4 py-2 text-xs text-teal-900" data-id="element-188" data-mp="1w0s2avszrpyp">
                        <span className="font-semibold" data-id="element-189" data-mp="1r1gljmsmkkh4">Your entry: </span>
                        {entry.what}
                        <span className="ml-2 text-teal-700/70" data-id="element-190" data-mp="1ma6uchrfh934">
                          · {entry.actionType} · sources {entry.sources.join(', ') || 'none cited'}
                        </span>
                      </td>
                    </tr>}
                </React.Fragment>;
          })}
          </tbody>
        </table>
      </div>

      {drawer && <FlagDrawer rowId={drawer.rowId} rowLabel={drawer.label} kind={drawer.kind} existing={flags[drawer.rowId]} onSave={saveFlag} onDelete={() => removeFlag(drawer.rowId)} onClose={() => setDrawer(null)} data-id="element-191" data-mp="830pqb0k8n4z" />}
    </div>;
}